<script>
import { createHOC } from 'vue-hoc'
import { queryUser, queryDepartmentUser } from '@centit/api-admin/cp'
import { Select } from '@centit/ui-form'

const options = {
  name: 'UserSelect',

  props: {
    tag: {
      type: String,
      default: 'T',
    },

    department: Boolean,
    unitCode: String,
  },
}

const renderWith = {
  props: {
    query() {
      return () => this.department && this.unitCode ? queryDepartmentUser(this.unitCode) : queryUser(this.tag)
    },
    valueField: 'userCode',
    textField: 'userName',
  },
}

export default createHOC(Select, options, renderWith)
</script>
